const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

console.log('API URL:', API_URL);

export { API_URL };